import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const DealsNearby = () => {
  const navigate = useNavigate();
  
  const [allProperties, setAllProperties] = useState([]);
  const [nearbyProperties, setNearbyProperties] = useState({});
  const [locationFetched, setLocationFetched] = useState(false);

  useEffect(() => {
    const fallbackProperties = [
      {
        _id: 'p1',
        title: 'Sea Breeze Apartments',
        brief: '2BHK with sea view and balcony',
        latitude: 19.0759,
        longitude: 72.8772,
        image: '1'
      },
      {
        _id: 'p2',
        title: 'Colonial Gateway Home',
        brief: 'Charming 3BHK near Gateway of India',
        latitude: 18.9218,
        longitude: 72.8347,
        image: '2'
      },
      {
        _id: 'p3',
        title: 'Juhu Garden Villa',
        brief: 'Luxury villa with garden and pool',
        latitude: 19.0988,
        longitude: 72.8260,
        image: '3'
      },
      {
        _id: 'p4',
        title: 'Andheri City View Flat',
        brief: '1BHK ideal for working professionals',
        latitude: 19.1197,
        longitude: 72.8468,
        image: '4'
      },
      {
        _id: 'p5',
        title: 'Bandra Studio Living',
        brief: 'Compact studio in posh location',
        latitude: 19.0550,
        longitude: 72.8296,
        image: '5'
      },
      {
        _id: 'p6',
        title: 'Powai Lake Residency',
        brief: 'Quiet neighborhood, stunning lake view',
        latitude: 19.1237,
        longitude: 72.9168,
        image: '6'
      },
      {
        _id: 'p7',
        title: 'Thane Green Enclave',
        brief: 'Spacious 3BHK with nature all around',
        latitude: 19.2183,
        longitude: 72.9781,
        image: '7'
      }
    ];
  
    const fetchProperties = async () => {
      try {
        const res = await axios.get("/api/properties");
        setAllProperties(res.data?.length ? res.data : fallbackProperties);
      } catch {
        setAllProperties(fallbackProperties);
      }
    };

    fetchProperties();
  }, []);

  const getDistanceInKm = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = 
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  const handleNearbyProperties = () => {
    if (!navigator.geolocation) {
      alert("Geolocation not supported by your browser");
      return;
    }

    navigator.geolocation.getCurrentPosition((position) => {
      const userLat = position.coords.latitude;
      const userLon = position.coords.longitude;

      const ranges = {
        'Within 2 Km': [],
        'Within 5 Km': [],
        'Within 10 Km': [],
        'Within 25 Km': [],
        'More than 25 Km': []
      };

      allProperties.forEach(property => {
        if (property.latitude && property.longitude) {
          const distance = getDistanceInKm(userLat, userLon, property.latitude, property.longitude);
          const propertyWithDistance = { ...property, distance };

          if (distance <= 2) ranges['Within 2 Km'].push(propertyWithDistance);
          else if (distance <= 5) ranges['Within 5 Km'].push(propertyWithDistance);
          else if (distance <= 10) ranges['Within 10 Km'].push(propertyWithDistance);
          else if (distance <= 25) ranges['Within 25 Km'].push(propertyWithDistance);
          else ranges['More than 25 Km'].push(propertyWithDistance);
        }
      });

      setNearbyProperties(ranges);
      setLocationFetched(true);
    }, () => {
      alert("Location access denied or failed");
    });
  };

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <h2 className="text-3xl font-bold text-teal-800 mb-4">Properties Near You</h2>

      <div className="mb-6">
        <button
          onClick={handleNearbyProperties}
          className="px-4 py-2 bg-teal-600 text-white rounded-full hover:bg-teal-700"
        >
          Refresh Nearby Listings
        </button>
      </div>

      {locationFetched && Object.keys(nearbyProperties).map(range => (
        nearbyProperties[range].length > 0 && (
          <div key={range} className="mb-8">
            <h3 className="text-xl font-semibold mb-3 text-green-800">{range}</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {nearbyProperties[range].map(property => (
                <div key={property._id} className="bg-white shadow-md p-4 rounded-xl">
                  <img 
                    src={`/api/downloads/property/images/${property.image || '1'}.jpg`}
                    alt={property.title}
                    className="w-full h-40 object-cover rounded"
                  />
                  <h4 className="mt-2 text-lg font-bold text-gray-700">{property.title}</h4>
                  <p className="text-sm text-gray-500">{property.brief}</p>
                  <p className="text-sm mt-1 text-gray-400">~{property.distance.toFixed(1)} km away</p>
                  <button 
                    onClick={() => navigate(`/property/${property._id}`)}
                    className="mt-3 px-4 py-2 bg-teal-500 text-white rounded-full text-sm hover:bg-teal-600"
                  >
                    View Details
                  </button>
                </div>
              ))}
            </div>
          </div>
        )
      ))}
    </div>
  );
};

export default DealsNearby;
